import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { IMAGES } from "@/config/siteConfig";
import { scrollToId } from "@/lib/scroll";
import { Reveal } from "@/components/Reveal";

export const InvestmentCTA = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} className="relative py-24 sm:py-32 lg:py-36 overflow-hidden" data-testid="investment-cta">
      <motion.img
        src={IMAGES.investment}
        alt="Premium commercial building"
        loading="lazy"
        style={{ y, scale: 1.25 }}
        className="absolute inset-0 w-full h-full object-cover will-change-transform"
      />
      <div className="absolute inset-0 bg-navy/85" />
      <div className="relative z-10 max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <Reveal>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-white leading-tight">
            Looking Beyond Just a Property<span className="text-gold">?</span>
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-5 text-sm sm:text-base lg:text-lg text-white/70 max-w-xl mx-auto leading-relaxed">
            The right property starts with the right information, location and decision.
          </p>
        </Reveal>
        <Reveal delay={0.22}>
          <button
            onClick={() => scrollToId("#enquire")}
            data-testid="investment-talk-to-expert-button"
            className="mt-9 bg-gold text-navy hover:bg-gold-dark hover:-translate-y-0.5 transition-all duration-300 rounded-lg px-8 py-4 text-[15px] font-semibold inline-flex items-center gap-2 shadow-lg shadow-gold/25"
          >
            Talk to a Property Expert <ArrowRight size={16} />
          </button>
        </Reveal>
      </div>
    </section>
  );
};
